import globalConfig from "./globalConfig";
import bridge from "./bridge";

/**
 * 活动跳转规则:
    1、支付页所有的活动跳转链接，均不带额外的cid和scid

    2、cid规则：
    直接继承访问支付页时带的cid，不要更换！
    如果是桌面快捷方式的话，去缓存寻找之前存下的cid，继续使用。（如果没有才转成web）

    3、scid规则：
    如果是桌面快捷方式的话，去缓存寻找之前存下的scid，继续使用。

    在支付页原本的scid上继续拼接banner/eventlist等入口标识
    1、主页大banner，使用webstore_banner
    2、支付页限时活动，使用webstore_eventlist

    例：支付页当前已有scid=activity_act001
    banner跳转活动时，拼接成scid=activity_act001_webstore_banner
    限时活动列表跳转活动时，拼接成scid=activity_act001_webstore_eventlist

    例：如果支付页当前没有scid，直接使用来源入口标识即可
    banner跳转活动时，拼接成scid=webstore_banner
    限时活动列表跳转活动时，拼接成scid=webstore_eventlist
 */


export const BANNER_ACTIVITY = 'webstore_banner'; // banner区域
export const EVENT_LIST_ACTIVITY = 'webstore_eventlist'; // 限时活动列表里面
export const NOTICE_POPUP_ACTIVITY = 'webstore_noticepopup'; // 提示弹窗里面
export const VIP_ACTIVITY = 'webstore_VIPpage'; // VIP页面里面
export const MAIN_BAR_ACTIVITY = 'webstore_mainbar'; // officialStore的顶栏 / officialWebStore的侧边栏

/**
 * 
 * @param {*} link 活动链接如：https://auto-page.${window.atob('MzdnYW1lcy5jb20=')}/myvip01/
 * @param {*} obj { language: 'en-US' }
 * @returns 
 */
function updateLinkParams(link, obj) {
  try {
    // 判断是否有加https或者http协议
    if (!(link.startsWith('http:') || link.startsWith('https:'))) {
      link = (window?.location?.protocol || 'https:') + link;
    }
    let url = new URL(link);
    for (let k in obj) {
      url.searchParams.set(k, String(obj[k]));
    }
    return url.href;
  } catch (error) {
    return String(link);
  }
}

/**
 * 
 * @param {*} type 活动的类型：放在banner中，传入变量：BANNER_ACTIVITY；放在活动列表中，传入变量：EVENT_LIST_ACTIVITY
 * @param {*} url 活动链接如：https://auto-page.${window.atob('MzdnYW1lcy5jb20=')}/myvip
 * @param {*} otherParams 其他参数如：{ language: 'en-US', cid: '默认会自动加上cid，使用指定的cid，就传入', scid: '默认会自动加上scid，使用指定的scid，就传入' }
 * @param {*} jumpConfig 跳转配置：{ target: '_blank', openWay: 'openBrowser' } target: 浏览器打开方式(其它值：_self)；openWay: SDK打开方式(其它值：openWebView)
 * @returns 
 */
export default function openActivity(type, url, otherParams = {}, jumpConfig = {
}) {
  if (!url) return;

  // 判断是不是pwa
  const boolPwa = globalConfig.getHrefParam('mode') === 'pwa';

  let payCid = '';
  let payScid = '';

  if (boolPwa) {
    try {
      const localPwaActivityCidStr = window.localStorage.getItem('pwaActivityScid');
      const localPwaActivityCidObj = JSON.parse(localPwaActivityCidStr);
      payCid = localPwaActivityCidObj?.cid || '';
      payScid = localPwaActivityCidObj?.scid || '';
    } catch (e) {
      console.error(e);
    }
  } else {
    payCid = globalConfig.getHrefParam('cid');
    payScid = globalConfig.getHrefParam('scid');
  }

  let activityCid = payCid;
  let activityScid = '';

  if (type === BANNER_ACTIVITY) {
    activityScid = payScid ? `${payScid}_${BANNER_ACTIVITY}` : BANNER_ACTIVITY;
  }
  if (type === EVENT_LIST_ACTIVITY) {
    activityScid = payScid ? `${payScid}_${EVENT_LIST_ACTIVITY}` : EVENT_LIST_ACTIVITY;
  }
  if (type === NOTICE_POPUP_ACTIVITY) {
    activityScid = payScid ? `${payScid}_${NOTICE_POPUP_ACTIVITY}` : NOTICE_POPUP_ACTIVITY;
  }
  if (type === VIP_ACTIVITY) {
    activityScid = payScid ? `${payScid}_${VIP_ACTIVITY}` : VIP_ACTIVITY;
  }
  if (type === MAIN_BAR_ACTIVITY) {
    activityScid = payScid ? `${payScid}_${MAIN_BAR_ACTIVITY}` : MAIN_BAR_ACTIVITY;
  }

  const newUrl = updateLinkParams(url, {
    cid: activityCid,
    scid: activityScid,
    ...otherParams
  });

  const defaultOpenWay = 'openBrowser'; // SDK默认打开方式
  const target = jumpConfig?.target || '_blank'; // 浏览器打开方式
  const openWay = jumpConfig?.openWay || defaultOpenWay; // SDK打开方式

  if (bridge.runInsdk()) {
    openWay === defaultOpenWay ? bridge.callSdkMethod(openWay, {
      url: newUrl,
      loginDir: 1,
      appendParams: 1
    }) : bridge.callSdkMethod(openWay, {
      url: newUrl,
      loginDir: 0,
      appendParams: 1
    });
  } else {
    window.open(newUrl, target);
  }
}